// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___2iKXm","content":"App__content___c2W3_","error":"App__error___1dV9j","game":"App__game___8fCGH","centerHorizontally":"App__centerHorizontally___2ny9Q","centerVertically":"App__centerVertically___1O6qc"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 99
// module chunks = 0